"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_toast_notifications_1 = require("react-toast-notifications");
var react_i18next_1 = require("react-i18next");
var app_1 = __importDefault(require("./app"));
var store_1 = require("./app/store");
require("./api/bootstrap");
var i18n_1 = __importDefault(require("./i18n"));
var use_query_params_1 = require("use-query-params");
var localization_1 = require("./helpers/localization");
var queryStringifyOptions = {
    transformSearchString: use_query_params_1.transformSearchStringJsonSafe,
};
react_dom_1.default.render(react_1.default.createElement(react_redux_1.Provider, { store: store_1.store },
    react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: i18n_1.default },
        react_1.default.createElement(react_router_dom_1.BrowserRouter, { basename: localization_1.getInitialLocalization(), getUserConfirmation: function () { } },
            react_1.default.createElement(use_query_params_1.QueryParamProvider, { ReactRouterRoute: react_router_dom_1.Route, stringifyOptions: queryStringifyOptions },
                react_1.default.createElement(react_toast_notifications_1.ToastProvider, null,
                    react_1.default.createElement(app_1.default, null)))))), document.getElementById('app'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
